import { Component, input, output, linkedSignal } from '@angular/core';
import { HlmCollapsibleImports } from '@spartan-ng/helm/collapsible';
import { ThemedIconComponent } from '../../atoms/themed-icon/themed-icon.component';

@Component({
  selector: 'ocp-panel',
  imports: [HlmCollapsibleImports, ThemedIconComponent],
  templateUrl: './panel.component.html',
  styleUrl: './panel.component.scss',
})
export class PanelComponent {
  readonly header = input.required<string>();
  readonly expanded = input(true);
  readonly disabled = input(false);
  readonly expandedChange = output<boolean>();

  protected readonly _expanded = linkedSignal(() => this.expanded());

  onExpandedChange(value: boolean): void {
    this._expanded.set(value);
    this.expandedChange.emit(value);
  }
}
